import React from 'react'
import style from './style.module.sass'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Button, createTheme, IconButton, Modal } from '@material-ui/core'
import { useTheme, ThemeProvider } from '@material-ui/styles'
import { Close } from '@material-ui/icons'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { useActions } from '../../../utils/action-helper'
import {
  dashboardClearAll,
  dashboardSetFilter,
  dashboardSetIdList,
  dashboardSetLanguage,
  dashboardSetType, tableSetDialog, tableSetOtherData
} from '../../../actions'
import { contrastCheckBox } from '../../../utils'



export default function ExportExcelModal ({
  exportExcelModal,
  setExportExcelModal,
  handleStartExport
}) {
  const { t } = useTranslation()
  const { theme: { bgColors, colors, borderColors } } = useTheme()
  const customTheme = contrastCheckBox(colors, createTheme)

  const {
     aTableSetOtherData
  } = useActions({
    aDashboardClearAll: dashboardClearAll,
    aDashboardSetFilter: dashboardSetFilter,
    aDashboardSetType:dashboardSetType,
    aDashboardSetLanguage:dashboardSetLanguage,
    aDashboardSetIdList:dashboardSetIdList,
    aTableSetDialog:tableSetDialog,
    aTableSetOtherData:tableSetOtherData
  })

  const otherData = useSelector(state => state.tableData.otherData)

  const exportList =  otherData.exportList

  const handleSelectRoot = (inx) =>{
    const tOtherData = {...otherData}
    const selected = tOtherData.exportList[inx].selected
    tOtherData.exportList[inx].selected = !selected
    tOtherData.exportList[inx].children =
      tOtherData.exportList[inx].children.map(v=>{return {...v, selected: !selected}})
    aTableSetOtherData(tOtherData)
  }

  const handleSelectChild = (rootInx, childInx) =>{
    const tOtherData = {...otherData}
    tOtherData.exportList[rootInx].children[childInx].selected = !tOtherData.exportList[rootInx].children[childInx].selected
    aTableSetOtherData(tOtherData)
  }

  return (
    <Modal open={exportExcelModal} onClose={() => setExportExcelModal(false)}
           className={`d-flex align-items-center justify-content-center`} >
      <div className={style.container} style={{backgroundColor: bgColors.bgPrimary0, color: colors.colorText, border: `1px solid ${borderColors.borderPrimary200}`}}>
        <div className={style.exportModal}>
          <div className={`${style.exportModal__head} d-flex align-items-center justify-content-between`} style={{backgroundColor: bgColors.bgPrimary200, borderBottom: `1px solid ${borderColors.borderPrimary200}`}}>
            <p className='m-0' style={{color: colors.colorText}}>{t('excel-export')}</p>
            <IconButton onClick={() => { setExportExcelModal(false) }} style={{color: colors.colorText}}>
              <Close />
            </IconButton>
          </div>
          <p className={`m-0 ${style.exportModal__subtitle}`} style={{color: colors.colorText, backgroundColor: bgColors.bgPrimary100}}>{t('choose-criteria')}</p>
          <div className={'m-0 pl-5'}>
            {exportList && exportList.map((v, rootInx) => <div className={'m-0 pb-3 block'} key={rootInx}>
              <FormControlLabel
                control={
                   <ThemeProvider theme={customTheme}>
                    <Checkbox
                      className={'m-0 p-0'}
                      checked={v.selected}
                      id={v.name}
                      color="primary"
                      onChange={e => handleSelectRoot(rootInx)}
                      inputProps={{ 'aria-label': v.selected ? t('Deselect') : t('Select') }}
                    />
                  </ThemeProvider>
                }
                label={<div className={'p-0 m-0'} style={{fontSize:'14px'}}>
                  {t(v.translation)}
                </div>}
              />
              <div className={'pl-3 m-0'}>
                {v.children.map( (child, childInx) => <div key={childInx} className={'p-0 m-0'}>
                  <FormControlLabel
                    control={
                      <ThemeProvider theme={customTheme}>
                      <Checkbox
                        className={'m-0 p-0'}
                        checked={child.selected}
                        id={child.name}
                        onChange={e => handleSelectChild(rootInx, childInx)}
                        color="primary"
                        inputProps={{ 'aria-label': v.selected ? t('Deselect') : t('Select') }}
                      />
                      </ThemeProvider>
                    }
                    label={<div className={'p-0 m-0'}  style={{fontSize:'14px'}}>
                      {child.useTranslation ?  t(child.translation) : child.translation}
                     </div>}
                  />
                </div>)}
              </div>
            </div>)}

          </div>

        </div>
        <div className={style.exportBtn}>
          <Button onClick={() => handleStartExport()} style={{backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast}} variant='contained'>{t('export')}</Button>
        </div>
      </div>
    </Modal>
    )
}